import React from "react";
import {Website} from "../layouts/Website";
import {PageTitle} from "../components/shared/PageTitle";
import {Box, Container, Grid, Typography} from "@mui/material";
import {HomeTextBlock} from "../components/shared/HomeTextBlock";
import {tempoLiberoMap} from "../data/tempoLiberoMap";
import {TempoLiberoTextBlock} from "../components/shared/TempoLiberoTextBlock";
import {TempoLiberoNew} from "../components/shared/TempoLiberoNew";

export const TempoLibero = () => {
    return (
        <Website>
            <Container sx={{py: 5}}>
                <PageTitle title={'Tempo Libero'} image={'icon-tempo-libero'}/>
                {/*<Box sx={{display:'flex', alignItems:'center', gap:'15px', mb:2}}>
                    <img src={require('../assets/icons/icon-day.png')} alt={'icon day'} width={'25px'} />
                    <Typography variant={'h6'} color={'#d1112c'}>
                        DAY TIME
                    </Typography>
                </Box>
                {tempoLiberoMap.map((item) =>
                    item.dayTime.map((section) => (
                        <TempoLiberoTextBlock section={section} direction={'row'}/>
                    ))
                )}*/}
                <Box sx={{display:'flex', alignItems:'center', gap:'15px',mb:2}}>
                    <img src={require('../assets/icons/icon-night.png')} alt={'icon day'} width={'25px'} />
                    <Typography variant={'h6'} color={'#d1112c'}>
                        NIGHTLIFE
                    </Typography>
                </Box>
                {tempoLiberoMap.map((item) =>
                    item.nightTime.map((section) => (
                        <TempoLiberoNew section={section} direction={'row'}/>
                    ))
                )}
            </Container>
        </Website>
    )
}
